import React, { useState } from "react";
import "../css/Portfolio.css";
import { useTheme } from "../../context/ThemeContext";
import Nav from "../portfolio/Nav";
import Hero from "../portfolio/Hero";
import Marquee from "../portfolio/Marquee";
import About from "../portfolio/About";
import Stack from "../portfolio/Stack";
import Experience from "../portfolio/Experience";
import Projects from "../portfolio/Projects";
import ProjectModal from "../portfolio/ProjectModal";
import ReleaseNotes from "../portfolio/ReleaseNotes";
import Writing from "../portfolio/Writing";
import Contact from "../portfolio/Contact";
import Footer from "../portfolio/Footer";
import projects from "../data/projects";

function Home() {
  const { theme } = useTheme();
  const [openProjectId, setopenProjectId] = useState(null);

  const openProject = projects.find((p) => p.id === openProjectId) || null;

  return (
    <div id="site" data-theme={theme}>
      <div id="top" />
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Stack />
      <Experience />
      <Projects onOpen={setopenProjectId} />
      <ReleaseNotes />
      <Writing />
      <Contact />
      <ProjectModal project={openProject} onClose={() => setopenProjectId(null)} />
      <Footer />
    </div>
  );
}

export default Home;
